import React from 'react';
import { View } from 'react-native';
import Svg, { Defs, RadialGradient, LinearGradient, Stop, Circle, Rect } from 'react-native-svg';
import { brand, grey } from '../styles/tokens';

/**
 * Soft brand aurora gradient veil for auth hero surfaces.
 *
 * Pulls colors from `tokens.brand` so a palette swap in one place updates
 * this background automatically. Light-mode composition: subtle purple
 * washes over a near-white base, with a faint vignette for depth.
 */
export const AuroraVeilBg: React.FC = () => {
  return (
    <View
      pointerEvents="none"
      style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}
    >
      <Svg width="100%" height="100%" viewBox="0 0 390 844" preserveAspectRatio="xMidYMid slice">
        <Defs>
          {/* primary brand glow */}
          <RadialGradient id="auroraPrimary" cx="70%" cy="0%" r="65%">
            <Stop offset="0%" stopColor={brand.purple1} stopOpacity="0.45" />
            <Stop offset="100%" stopColor={brand.purple4} stopOpacity="0" />
          </RadialGradient>
          {/* deep brand accent */}
          <RadialGradient id="auroraAccent" cx="100%" cy="35%" r="60%">
            <Stop offset="0%" stopColor={brand.purple0} stopOpacity="0.30" />
            <Stop offset="100%" stopColor={brand.purple4} stopOpacity="0" />
          </RadialGradient>
          {/* soft tint wash */}
          <RadialGradient id="auroraTint" cx="10%" cy="65%" r="55%">
            <Stop offset="0%" stopColor={brand.purple3} stopOpacity="0.55" />
            <Stop offset="100%" stopColor={brand.purple4} stopOpacity="0" />
          </RadialGradient>
          {/* subtle top-to-bottom vignette to add depth */}
          <LinearGradient id="vignette" x1="0" y1="0" x2="0" y2="1">
            <Stop offset="0%" stopColor={grey[500]} stopOpacity="0.02" />
            <Stop offset="100%" stopColor={grey[500]} stopOpacity="0.06" />
          </LinearGradient>
        </Defs>

        {/* base wash layers */}
        <Circle cx="300" cy="20" r="240" fill="url(#auroraPrimary)" />
        <Circle cx="420" cy="260" r="220" fill="url(#auroraAccent)" />
        <Circle cx="-30" cy="620" r="240" fill="url(#auroraTint)" />
        {/* extra soft center highlight for visibility */}
        <Circle cx="200" cy="200" r="160" fill="url(#auroraPrimary)" />

        {/* soft vignette */}
        <Rect x="0" y="0" width="390" height="844" fill="url(#vignette)" />
      </Svg>
    </View>
  );
};

export default AuroraVeilBg;
